import React, { useRef } from 'react';

import useCommentVideoEmbed from 'hooks/useCommentVideoEmbed';

import MentionParser from 'components/ui-components/mention-parser';

import styles from './styles.module.less';

const PostBody = props => {
  const { content } = props;
  const postRef = useRef();

  useCommentVideoEmbed(postRef);

  return (
    <MentionParser
      forwardRef={postRef}
      className={styles.postBody}
      comment={content}
      withPills={true}
    />
  );
};

export default PostBody;
